import BannerImage, { BannerImageProps } from './BannerImage';

export default BannerImage;
export type { BannerImageProps };
